import { render, staticRenderFns } from "./PatientServiceRequest.vue?vue&type=template&id=56ae1e2c&scoped=true"
import script from "./PatientServiceRequest.vue?vue&type=script&lang=js"
export * from "./PatientServiceRequest.vue?vue&type=script&lang=js"
import style0 from "./PatientServiceRequest.scss?vue&type=style&index=0&id=56ae1e2c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae1e2c",
  null
  
)

export default component.exports